import { useCallback, useEffect, useState } from "react";
import { isAuthenticated } from "../../auth";
import { getProviderStorefront } from "../services/storefrontService";
import { listProviderCatalogForSeller, listProviderFacets } from "../services/providerProductService";
import { elakayAutoText } from "../../pageInside/dataElakay";

const ok = (r) => r && !r.error && r.success !== false;
const PRODUCT_LIMIT = 50; // the catalogue endpoint's page cap; the full catalogue page has pagination

// Everything a Provider storefront renders, from the SAME professional-only endpoints for every viewer
// (Seller on the public route, the Provider in its own Customer View): published storefront + real
// statistics, the Provider's active products (with each viewer's own Seller link state) and categories.
// `shopId` (multi-shop, optional): one of the Provider's shops; null = its original shop.
export default function useProviderStorefront(providerId, shopId = null) {
  const [state, setState] = useState({ loading: true, error: "", status: null, storefront: null, products: [], categories: [] });
  const load = useCallback(async () => {
    if (!providerId) { setState((s) => ({ ...s, loading: false })); return; }
    const token = isAuthenticated()?.token;
    setState((s) => ({ ...s, loading: true }));
    const [storefront, catalog, facets] = await Promise.all([
      getProviderStorefront(token, providerId, shopId),
      listProviderCatalogForSeller(token, { providerId, shopId, page: 1, limit: PRODUCT_LIMIT, sort: "new" }),
      listProviderFacets(token, { providerId, ...(shopId && { shopId }) }),
    ]);
    if (!ok(storefront)) {
      setState({ loading: false, error: storefront?.error || elakayAutoText("h_7f2f6a15cf8da2", "Error"), status: storefront?.status || null, storefront: null, products: [], categories: [] });
      return;
    }
    setState({
      loading: false,
      error: "",
      status: 200,
      storefront,
      products: ok(catalog) ? catalog.items || [] : [],
      categories: ok(facets) ? facets.categories || [] : [],
    });
  }, [providerId, shopId]);
  useEffect(() => { load(); }, [load]);
  return { ...state, reload: load };
}
